import React from "react";

const Map = () => {
  return <div id="app-map"></div>;
};

export default Map;
